export function isNonNulled(value) {
    return value != null;
}
export const isNotNullish = isNonNulled;
export function isNulled(value) {
    return value == null;
}
export const isNullish = isNulled;
export function isObservable(value) {
    return Boolean(value &&
        typeof value === "object" &&
        typeof value["subscribe"] === "function");
}
export function isScheduler(value) {
    return Boolean(value && typeof value["schedule"] === "function");
}
//# sourceMappingURL=util.js.map